var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.02297 11.5235C10.195 11.5235 11.1451 10.5734 11.1451 9.40139C11.1451 8.22939 10.195 7.2793 9.02297 7.2793C7.85097 7.2793 6.90088 8.22939 6.90088 9.40139C6.90088 10.5734 7.85097 11.5235 9.02297 11.5235Z",
    fill: "#089A21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9491 8.69053C16.3251 7.0765 15.2418 5.68067 13.8332 4.67558C12.4246 3.67049 10.7523 3.10018 9.02305 3.03516C7.29382 3.10018 5.62154 3.67049 4.21291 4.67558C2.80427 5.68067 1.72102 7.0765 1.09704 8.69053C1.05489 8.80709 1.05489 8.93473 1.09704 9.05129C1.72102 10.6653 2.80427 12.0612 4.21291 13.0662C5.62154 14.0713 7.29382 14.6416 9.02305 14.7067C10.7523 14.6416 12.4246 14.0713 13.8332 13.0662C15.2418 12.0612 16.3251 10.6653 16.9491 9.05129C16.9912 8.93473 16.9912 8.80709 16.9491 8.69053ZM9.02305 12.3193C8.34102 12.3193 7.67431 12.1171 7.10722 11.7382C6.54014 11.3592 6.09815 10.8207 5.83715 10.1906C5.57614 9.56044 5.50785 8.86709 5.64091 8.19816C5.77397 7.52924 6.1024 6.91479 6.58466 6.43252C7.06693 5.95026 7.68138 5.62183 8.3503 5.48877C9.01923 5.35571 9.71259 5.424 10.3427 5.685C10.9728 5.94601 11.5114 6.388 11.8903 6.95508C12.2692 7.52217 12.4715 8.18888 12.4715 8.87091C12.4701 9.78505 12.1063 10.6614 11.4599 11.3077C10.8135 11.9541 9.93719 12.3179 9.02305 12.3193Z",
    fill: "#089A21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.3637fa2ddeae7bf7e41348ba887432a0.svg";
export { ForwardRef as ReactComponent };